<template>
    <div>
        <span v-if="disabled && selections.length == 0">No Values</span>
        <b-list-group v-else>
            <b-list-group-item
                v-for="(item, idx) in selections"
                :key="`item-${idx}`"
                class="flex-column align-items-start"
            >
                <div class="d-flex w-100 justify-content-between">
                    <span>{{ item }}</span>
                    <b-button
                        v-if="!disabled"
                        size="sm"
                        @click="deleteSelection(idx)"
                        >X</b-button
                    >
                </div>
            </b-list-group-item>
            <b-list-group-item
                v-if="!disabled"
                class="flex-column align-items-start"
            >
                <div class="d-flex w-100 justify-content-between">
                    <b-form-input
                        v-model="newSelection"
                        id="inline-form-input-name"
                        class="mb-2 mr-sm-2 mb-sm-0"
                        placeholder="New Selection"
                    ></b-form-input>
                    <b-button size="sm" variant="primary" @click="addSelection"
                        >Add</b-button
                    >
                </div>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>
<script>
export default {
    name: 'SelectionValues',
    data: () => ({
        selections: [],
        newSelection: '',
    }),
    props: {
        value: {
            type: Array,
            default() {
                return []
            },
        },
        disabled: {
            type: Boolean,
            default: true,
        },
    },
    watch: {
        value: {
            handler: function (val) {
                this.selections = val || []
            },
            deep: true,
        },
        selections: {
            handler: function (val) {
                this.$emit('input', val)
            },
            deep: true,
        },
    },
    mounted() {
        this.selections = this.value || []
    },
    methods: {
        deleteSelection(idx) {
            this.selections.splice(idx, 1)
        },
        addSelection() {
            console.log('selections', this.selections)
            console.log('new selection', this.newSelection)
            if (
                this.newSelection &&
                !this.selections.find(
                    x => x.toLowerCase() === this.newSelection.toLowerCase()
                )
            ) {
                this.selections.push(this.newSelection)
                this.newSelection = ''
            }
        },
    },
}
</script>